import { defineComponent as _defineComponent } from 'vue';
import { useOrderStatus } from "@js/vue/domain/order/composables/useOrderStatus";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderStatusIndicator',
    props: {
        status: {
            type: String,
            required: false,
            default: ''
        },
        showText: {
            type: Boolean,
            default: true
        }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const { getStatusStyle, isStatusVisible } = useOrderStatus();
        const visible = isStatusVisible(props.status);
        const style = getStatusStyle(props.status);
        const __returned__ = { props, getStatusStyle, isStatusVisible, visible, style };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
